import { HttpMethod } from "../types/index.js";
export default function (provider) {
  return {
    addConversationCircle(id, body) {
      return provider.send(`/conversation/${id}/circles`, HttpMethod.POST, body);
    },

    addUserToCircle(id, body) {
      return provider.send(`/users/${id}/circles`, HttpMethod.POST, body);
    },

    createCircle(body) {
      return provider.send("/circles", HttpMethod.POST, body);
    },

    deleteCircle(id) {
      return provider.send(`/circles/${id}/delete`, HttpMethod.POST);
    },

    getCircle(id) {
      return provider.send(`/circles/${id}`, HttpMethod.GET);
    },

    getCircleConversations(id, params) {
      return provider.send(`/circles/${id}/conversations`, HttpMethod.GET, "", params);
    },

    getCircles() {
      return provider.send("/circles", HttpMethod.GET);
    },

    removeConversationCircle(id, body) {
      return provider.send(`/conversation/${id}/circles`, HttpMethod.POST, body);
    },

    removeUserFromCircle(id, body) {
      return provider.send(`/users/${id}/circles`, HttpMethod.POST, body);
    },

    updateCircle(id, body) {
      return provider.send(`/circles/${id}`, HttpMethod.POST, body);
    }

  };
}